import React, { useEffect, useRef, useState } from 'react';
import CatService from '../../../service/CatService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { Messages } from 'primereact/messages';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';

function CompOutcomeMap(props){
	const [message,setMessage] = useState(null);
	const [cats,setCats] = useState([]);
	const weightOptions=[
		{label:'0.0',value:0},
		{label:'0.1',value:0.1},
		{label:'0.2',value:0.2},
		{label:'0.3',value:0.3},
		{label:'0.4',value:0.4},
		{label:'0.5',value:0.5},
		{label:'0.6',value:0.6},
		{label:'0.7',value:0.7},
		{label:'0.8',value:0.8},
		{label:'0.9',value:0.9},
		{label:'1.0',value:1},
	]
	const load=()=>{
		console.log("loading rels...");
		var ret=CatService.getChildRels(props.cat.id,"OUTCOME");
		ret.then((cats)=>{
			cats.forEach((element,index) => {
				element.index=index;
			});
			setCats(cats);
		});
	}
	useEffect(()=>{
		load();
	},[props]);
	const setWeight=(cat,value)=>{		
		var ind = findIndex(cat);
		if(ind<0)
			return;
		var ret=CatService.addCatRel(props.cat.id,cat.id,value);
		ret.then((rel)=>{
			setCats(prevCats=>{
				let _cat = {...prevCats[ind],relWeight:value};
				let _cats = [...prevCats];
				_cats[ind] = _cat;
				return _cats;
			});
		});
	}
	const setRelWeight2 = (cat,value) => {

		setCats(prev => prev.map(row => 
			row.id === cat.id ? { ...row, ['relWeight']: value } : row
		));
	};	

	const findIndex=(cat)=>{
		for(var i=0; i<cats.length; i++)
		{
			if(cats[i].id == cat.id)
				return i;
		}
		return -1;
	}
	const weightTemplate=(cat)=>{
		return <Dropdown options={weightOptions} value={cat.relWeight} 
			optionLabel='label' optionValue='value'
			style={{width:'6em'}}
			onChange={(e) => setWeight(cat,e.value)}></Dropdown>;
	}
	return(
			<div className="">
			<Messages ref={message}></Messages>
			<Toolbar className="mt-2 mb-2"/>

			<DataTable value={cats} showGridlines className="p-datatable-striped p-datatable-sm" dataKey="id">
				<Column field="id" header="Id" style={{width:'10%'}} sortable></Column>
				<Column field="code" header="Code" style={{width:'10%'}} sortable></Column>
				<Column field="name" header="Name" style={{width:'50%'}} sortable></Column>
				<Column field="path" header="Path" style={{width:'20%'}} sortable></Column>
				<Column field="relWeight" header="Weight" body={weightTemplate} style={{width:'20%'}} sortable></Column>
			</DataTable>
			</div>
	)
}
export default CompOutcomeMap;
